import * as URLToolkit from 'url-toolkit';

export function getQueryParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null && r[2] !== '') return r[2].toString();
    return '';
}

function getBrowserRTC () {
    if (typeof window === 'undefined') return null
    var wrtc = {
        RTCPeerConnection: window.RTCPeerConnection || window.mozRTCPeerConnection ||
            window.webkitRTCPeerConnection,
        RTCSessionDescription: window.RTCSessionDescription ||
            window.mozRTCSessionDescription || window.webkitRTCSessionDescription,
        RTCIceCandidate: window.RTCIceCandidate || window.mozRTCIceCandidate ||
            window.webkitRTCIceCandidate
    }
    if (!wrtc.RTCPeerConnection) return null
    return wrtc
}

export function isWebRTCSupported() {
    const browserRTC = getBrowserRTC();
    return !!(browserRTC && (browserRTC.RTCPeerConnection.prototype.createDataChannel !== undefined));
}

function _getUA() {
    return navigator.userAgent.toLowerCase();
}

function _platform(os) {
    var ver = ('' + (new RegExp(os + '(\\d+((\\.|_)\\d+)*)').exec(_getUA()) || [, 0])[1]);
    // undefined < 3 === false, but null < 3 === true
    return ver || undefined;
}

function _toNum(str) {
    return parseFloat((str || "").replace(/\_/g, '.')) || 0;
}

export function isAndroid() {
    return _toNum(_platform('android[/ ]'));
}

export function isIOS() {
    return _toNum(_platform('os '));
}

export function isMobile() {
    return isAndroid() || isIOS();
}

function getMediaSource () {
    if (typeof self === 'undefined') return undefined;
    return self.ManagedMediaSource || self.MediaSource || self.WebKitMediaSource;
}

function getSourceBuffer() {
    return self.SourceBuffer || self.WebKitSourceBuffer;
}

export function isMSESupported () {
    const mediaSource = getMediaSource();
    if (!mediaSource) {
        return false;
    }

    // if SourceBuffer is exposed ensure its API is valid
    // Older browsers do not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
    const sourceBuffer = getSourceBuffer();
    return (
        !sourceBuffer ||
        (sourceBuffer.prototype &&
            typeof sourceBuffer.prototype.appendBuffer === 'function' &&
            typeof sourceBuffer.prototype.remove === 'function')
    );
}

export function loadScript(url) {
    let el = document.querySelector<HTMLScriptElement>(`script[src="${url}"]`)
    if (el) {
        return Promise.resolve()
    }
    const script = document.createElement("script");
    script.type = "text/javascript";
    return new Promise((resolve, reject) => {
        script.onload = resolve;
        script.onerror = reject;
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    })
}

export function loadScripts(urls) {
    const promises = urls.map(url => loadScript(url))
    return Promise.all(promises)
}

export function getUrlSuffix(url) {
    const urlObj = URLToolkit.parseURL(url);
    let ret = urlObj.path.substring(urlObj.path.lastIndexOf('.')+1);
    if (ret.endsWith('/')) {
        ret = ret.substring(0, ret.length-1)
    }
    return ret
}

